import UsersDevicesTable from "./users-devices-table";

export default UsersDevicesTable